<div class="app-c-card">
    <div class="app-c-card__content">
      <h2 class="example-h2">Checkbox configuration</h2>

      <section class="example-section">
        <label class="app-c-checkbox example-margin">
          <input type="checkbox" [(ngModel)]="checked" />
          <span>Checked</span>
        </label>
        <label class="app-c-checkbox example-margin">
          <input type="checkbox" [(ngModel)]="indeterminate" />
          <span>Indeterminate</span>
        </label>
      </section>

      <section class="example-section">
        <label class="example-margin">Align:</label>
        <label class="app-c-radio example-margin">
          <input type="radio" [(ngModel)]="labelPosition" value="after" />
          <span>After</span>
        </label>
        <label class="app-c-radio example-margin">
          <input type="radio" [(ngModel)]="labelPosition" value="before" />
          <span>Before</span>
        </label>
      </section>

      <section class="example-section">
        <label class="app-c-checkbox example-margin">
          <input type="checkbox" [(ngModel)]="disabled" />
          <span>Disabled</span>
        </label>
      </section>
    </div>
  </div>

  <div class="app-c-card">
    <div class="app-c-card__content">
      <h2 class="example-h2">Result</h2>

      <section class="example-section">
        <label class="app-c-checkbox example-margin">
          <input type="checkbox" [(ngModel)]="checked" [disabled]="disabled" />
          <span>I'm a checkbox</span>
        </label>
      </section>
    </div>
  </div>
